<template>
  <v-card>
    <v-card-title>
        Adicionar um novo tipo de pagamento
    </v-card-title>
    <v-container flex fluid grid-list-sm>
      <v-form lazy-validation v-model="valid" ref="formPag">
        <v-layout column>
            <v-flex>
                <v-text-field
                  label="Descrição"
                  :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                  v-model="dadosTipoPag.descricao"
                  required
                >
                </v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field
                    v-model="dadosTipoPag.referencia"
                    label="Referência"
                    hint="Essa informação será usada dentro da API para ela comparar qual tipo de pagamento está sendo utilizado pelo cliente, no caso do cartão"
                >
                </v-text-field>
            </v-flex>
            <v-flex>
              <span class="headline body-2">
                O tipo de pagamento é:
              </span>
              <v-radio-group row v-model="em_cartao">
                <v-radio label="No cartão" color="primary" :value="true"></v-radio>
                <v-radio label="Em espécie" color="primary" :value="false"></v-radio>
              </v-radio-group>
            </v-flex>
        </v-layout>
      </v-form>
    </v-container>
    <v-card-actions>
        <v-btn flat color="info" @click="fechar()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="loading" flat color="info" @click="inserirTipoPagamento">Confirmar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  data () {
    return {
      em_cartao: false,
      valid: false,
      dadosTipoPag: {
        descricao: null,
        referencia: null,
        cartao: false,
        especie: true
      }
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    em_cartao (val) {
      this.dadosTipoPag.cartao = val
      this.dadosTipoPag.especie = !val
    }
  },
  methods: {
    fechar () {
      this.$refs.formPag.reset()
      this.$emit('fechar')
    },
    inserirTipoPagamento () {
      if (this.$refs.formPag.validate()) {
        this.$store.dispatch('cadastroTipoPagamento', this.dadosTipoPag).then(() => {
          this.$emit('info', 'Tipo de pagamento inserido com sucesso')
          this.fechar()
        }).catch(() => {
          this.$emit('error', 'O tipo de pagamento não pôde ser inserido')
          this.fechar()
        })
      }
    }
  }
}
</script>
